import { motion } from "motion/react";
import type React from "react";
import { useTranslation } from "react-i18next";
import { BlockButton as UntypedBlockButton } from "../../inJoy-components/Button/BlockButton";

const BlockButton = UntypedBlockButton as any;

const imgLogo = "/img/logo_word_color.svg";

export const GameStartScreen: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="bg-white flex flex-col items-center justify-between min-h-screen p-5 relative w-full mx-auto overflow-hidden">
			{/* Logo */}
			<motion.div
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5 }}
				className="w-[109px] h-[24px] mt-6 shrink-0"
			>
				<img
					alt="inJOY Logo"
					className="w-full h-full object-contain"
					src={imgLogo}
				/>
			</motion.div>

			{/* Main Message */}
			<motion.div
				initial={{ opacity: 0, scale: 0.9 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{ duration: 0.5, delay: 0.2 }}
				className="flex flex-col items-center justify-center gap-3 text-center flex-1"
			>
				<h1 className="text-[48px] font-semibold text-color_text_positive_4 leading-tight tracking-tight">
					{t("guest.countdown.game_on")}
				</h1>
			</motion.div>

			{/* Bottom Card */}
			<motion.div
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5, delay: 0.4 }}
				className="bg-color_background_grey_1 border border-color_background_grey_2 rounded-lg p-3 pt-5 pb-4 w-full flex flex-col items-center gap-3 shrink-0"
			>
				<img
					className="w-[186px]"
					src={`${import.meta.env.VITE_APP_WEBSITE_URL}/img/event-page/game_info_thumbnail.png`}
					alt="promo thumbnail"
				/>
				<p className="Body2 text-color_text_grey_4 text-center">
					{t("guest.countdown.after_ends")}
				</p>

				<div className="w-full">
					<BlockButton
						type="Tertiary"
						size="Large"
						width="100%"
						children={t("guest.countdown.view_stats_video")}
					/>
				</div>
			</motion.div>
		</div>
	);
};
